// @flow

const LOCAL_STORAGE_KEY = 'tectonicsLookAndFeelCode';

export function getInitialLookAndFeelCode(): ?string {
  return window.location.hash.substring(1);
}

export function persistSelectedLookAndFeelCode(lookAndFeelCode: string) {
  window.location.hash = lookAndFeelCode;
  localStorage.setItem(LOCAL_STORAGE_KEY, lookAndFeelCode);
}
